// assets
import { IconChecklist, IconList, IconStackFront } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconBRERules: IconChecklist,
  IconBRERuleList: IconList,
  IconBRETemplateList: IconStackFront
};

// ==============================|| MENU ITEMS - BRE MASTER ||============================== //

const breMaster: NavItemType = {
  id: 'bre-master',
  title: 'BRE Master',
  type: 'group',
  icon: icons.IconBRERules,
  children: [
    {
      id: 'bre-master-rules',
      title: 'Rules',
      type: 'item',
      url: '/bre-master/rules',
      icon: icons.IconBRERuleList,
      breadcrumbs: false
    },
    {
      id: 'bre-master-templates',
      title: 'Templates',
      type: 'item',
      url: '/bre-master/templates',
      icon: icons.IconBRETemplateList,
      breadcrumbs: false
    }
  ]
};

export default breMaster;